import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";
import { TypeCalendrier } from "../../shared/models/typeCalendrier";

@Component({
	components: {
		CalendrierComponent: require("../calendrier/calendrier.vue.html"),
		CardActivityComponent: require("./cards/cardActivity/cardActivity.vue.html"),
		CardAlertComponent: require("./cards/cardAlert/cardAlert.vue.html"),
		CardNewsComponent: require("./cards/cardNews/cardNews.vue.html"),
		CardWorkforceComponent: require("./cards/cardWorkforce/cardWorkforce.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		if (from.path == "/") {
			next();
		} else {
			next(() => {
				EventBus.$emit(EventConstants.RELOAD_ACCUEIL);
			});
		}
	}
})
export default class MenuComponent extends Vue {
	public paieEnable = false;
	public typeCalendrierAccueil = TypeCalendrier.Accueil;

	public mounted(): void {
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
    	});
    	this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
	}
}



// WEBPACK FOOTER //
// ./src/components/home/home.ts